module.exports = __webpack_public_path__ + "static/img/img1.9521bcf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/news/img1.jpg
// module id = V8D7
// module chunks = 1